import { Link } from 'react-router-dom'
import { useTranslation } from '@/i18n'

export function GameModePlaceholderPage({
  badge,
  badgeClassName,
  title,
  subtitle,
}: {
  badge: string
  badgeClassName: string
  title: string
  subtitle: string
}) {
  const { t } = useTranslation()
  return (
    <div className="space-y-6">
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-1.5 text-sm text-surface-500 transition hover:text-surface-300"
      >
        ← {t('Terug naar Home')}
      </Link>

      <div className="rounded-[1.5rem] border border-white/[0.06] bg-white/[0.02] p-6 sm:p-8">
        <span
          className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] ${badgeClassName}`}
        >
          {t(badge)}
        </span>
        <h1 className="mt-3 text-2xl font-black tracking-tight text-white sm:text-3xl">{t(title)}</h1>
        <p className="mt-3 max-w-xl text-sm leading-6 text-surface-400">{t(subtitle)}</p>

        <div className="mt-6 rounded-[1.1rem] bg-white/[0.03] px-4 py-4 text-sm text-surface-300">
          {t('Deze spelmodus komt binnenkort beschikbaar.')}
        </div>
      </div>
    </div>
  )
}
